<template>
    <div id="game" class="game futura row" v-if="gm.players && gm.players.length > 0">
        <div class="col-12" v-if="gm.inGamePlayerCheck(logged_in_user)">
            <a href="/matchrequests" class="btn btn-danger btn-lg btn-block">{{__('games.end_watch')}}</a>
        </div>

        <div class="cricketHeader">
            <div class="cricketField">
                <div class="numbers d-none d-xl-flex">
                    <div class="name label">{{__('games.player')}}</div>
                    <div :class="['number', closedCheck(number)]" v-for="number in numbers" :key="number">{{number == 25 ? "B" : number}}</div>
                    <div class="score label">{{__('games.points')}}</div>
                </div>
                <div :class="['cricket-player', gm.isActivePlayer(player.id) ? 'active' : '']" v-for="player, idx in gm.players" :key="idx">
                    <div class="numbers d-xl-none">
                        <div :class="['number', closedCheck(number)]" v-for="number in numbers" :key="number">{{number == 25 ? "B" : number}}</div>
                    </div>
                    <div class="setslegs">
                        <div class="sets">{{__('games.sets')}}: {{player.sets}}</div>
                        <div class="legs">{{__('games.legs')}}: {{player.legs}}</div>
                    </div>
                    <div class="name">
                        <div class="round-end" v-if="gm.roundFinished && gm.isActivePlayer(player.id)">
                            <div class="round-end-text">{{__('games.round_ended')}}.<br>{{__('games.remove_darts')}}</div>
                        </div>
                        <div class="player-name">{{player.name}} <i class="fas fa-circle" v-if="checkStartingPlayer(player.id)"></i> </div>
                        <div class="player-singlescores" v-if="gm.isActivePlayer(player.id)">
                            <div :class="['throw1']">{{player.singlescores[0] ? player.singlescores[0].str : ''}}&nbsp;</div>
                            <div :class="['throw2']">{{player.singlescores[1] ? player.singlescores[1].str : ''}}&nbsp;</div>
                            <div :class="['throw3']">{{player.singlescores[2] ? player.singlescores[2].str : ''}}&nbsp;</div>
                        </div>
                    </div>
                    <div :class="['player-number', cricketNumberState(number, player)]" v-for="number in numbers" :key="number" v-html="cricketCounter(player.hits[number])"></div>
                    <div class="score">{{player.score}}</div>
                </div>
            </div>
        </div>

         <div class="subnav" v-if="layoutProfile && (layoutProfile.show_history || layoutProfile.show_numpad)">
            <a href="#" v-if="layoutProfile &&layoutProfile.show_numpad" :class="['item', showmenu == 'numpad' ? 'active' : 'inactive']" @click="showSubMenu('numpad')"><i class="fas fa-th"></i> {{__('games.input')}}</a>
            <a href="#" v-if="layoutProfile &&layoutProfile.show_history" :class="['item', showmenu == 'history' ? 'active' : 'inactive']" @click="showSubMenu('history')"><i class="fas fa-list-ol"></i> {{__('games.history')}}</a>
        </div>

        <div class="flexrow" v-if="layoutProfile">
            <div class="numpad shadow-inactive" v-if="showmenu =='numpad' && layoutProfile.show_numpad">
                <numpad :disabledInput='disabledInput' @add="add" @clr="clr" @send="send"></numpad>
            </div>
            <numpad hidden="true" :disabledInput='disabledInput'  @add="add" @clr="clr" @send="send" ref="numpad" v-if="!layoutProfile.show_numpad || showmenu != 'numpad'"></numpad>
            <div class="history shadow-inactive" v-if="showmenu =='history' && layoutProfile.show_history">
                <game-asset-game-history
                    :content="historyContent()"
                    :headers ="historyHeaders"
                    :players="gm.players"
                />
            </div>
        </div>

        <b-modal id="modal-leg-end" title="Leg beendet" @hidden="nextLeg">
            <div class="results">
                <div class="cricketHeader">
                     <div class="cricketField">
                        <div class="numbers">
                            <div class="name label">{{__('games.player')}}</div>
                            <div :class="['number', closedCheck(number)]" v-for="number in numbers" :key="number">{{number == 25 ? "B" : number}}</div>
                            <div class="score label">{{__('games.points')}}</div>
                        </div>
                        <div class="cricket-player active" v-for="player, idx in gm.players" :key="idx">
                            <div class="setslegs">
                                <div class="sets">{{__('games.sets')}}: {{player.sets}}</div>
                                <div class="legs">{{__('games.legs')}}: {{player.legs}}</div>
                            </div>
                            <div class="name">
                                <div class="player-name">{{player.name}} <i class="fas fa-circle"></i> </div>
                                <div class="player-singlescores">
                                    <div :class="['throw1']">{{player.singlescores[0] ? player.singlescores[0].str : ''}}&nbsp;</div>
                                    <div :class="['throw2']">{{player.singlescores[1] ? player.singlescores[1].str : ''}}&nbsp;</div>
                                    <div :class="['throw3']">{{player.singlescores[2] ? player.singlescores[2].str : ''}}&nbsp;</div>
                                </div>
                            </div>
                            <div :class="['player-number', cricketNumberState(number, player)]" v-for="number in numbers" :key="number" v-html="cricketCounter(player.hits[number])"></div>
                            <div class="score">{{player.score}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="history shadow-light mt-3">
                <game-asset-game-history
                   :content="historyContent()"
                    :headers ="historyHeaders"
                    :players="gm.players"
                />
            </div>
            <template #modal-footer>
                <game-asset-next-leg @nextleg="nextLeg"></game-asset-next-leg>
            </template>
        </b-modal>
        <game-asset-determine-start-player :startDetermineStartPlayer="startingPlayerDetermined" :firstleg="gm.firstleg" :game="game" @activePlayer="setStartingPlayer" :gameState="gm.gameState" :players="gm.players"></game-asset-determine-start-player>
        <game-asset-game-results-cricket :game="game" :playersProp="gm.players" :gm="gm" :showResults="showResults"></game-asset-game-results-cricket>
    </div>
</template>

<script>
    import numpad from './gameAssets/gameAssetNumpadCricket.vue';
    import GameAssetScorePlayer from './gameAssets/gameAssetScorePlayer.vue';
    import GameAssetGameHistory from './gameAssets/gameAssetGameHistory.vue';
    import GameAssetDetermineStartPlayer from './gameAssets/gameAssetDetermineStartPlayer.vue';
    import GameManger from './gameAssets/gameManager';
import DartsParser from './gameAssets/gameDartsParser';
import AudioPlayer from './gameAssets/gameAssetAudioPlayer.js';
    export default {
        props: ['game_prop', 'players_prop', 'logged_in_user', 'logged_in_player'],
        mixins: [AudioPlayer],
        components: {
            numpad,
            GameAssetScorePlayer,
            GameAssetGameHistory,
            GameAssetDetermineStartPlayer
        },
        data() {
            return {
                dartcounter: 0,
                hits_player1: {},
                hits_player2: {},
                throw_player1: 0,
                throw_player2: 0,
                singlescores_player1: [],
                singlescores_player2: [],
                throw: 0,
                game: this.game_prop,
                content: {},
                winner: null,
                disabledInput: true,
                watchstarted: false,
                numbers: [20,19,18,17,16,15,25],
                startingPlayerDetermined: false,
                gameState: [],
                hitsRoundStart: [],
                scoreRoundStart: 0,

                layoutProfile: null,
                showmenu: 'numpad',
                showResults: false,
                historyHeaders: [
                    {name: "Geworfen", value: "singlescores"},
                    {name: "Punkte", main: true, value: "score"},
                ],
            }
        },
        created() {
            this.gm = new GameManger(this);
            this.gm.start();
        },
        mounted() {

            if (this.game.status == "completed") {
                return;
            }
            this.layoutProfile = window.currentProfile ? window.currentProfile : {layout: 1, show_history: true, show_numpad: true};
            if (!this.layoutProfile.show_numpad && this.layoutProfile.show_history) this.showmenu = 'history';
        },
        methods: {

            createPlayers() {
                 return new Promise((resolve, reject) => {
                    //create the players used in this game
                    //TODO: do not use player1_prop, use relationship table game has many players through.
                    this.gm.createPlayerObjects([this.player1_prop, this.player2_prop]);
                    resolve();
                })
            },
            createUIElements() {
                return new Promise((resolve, reject) => {
                    resolve();
                })
            },
            setPlayerOptions() {
                return new Promise((resolve, reject) => {
                    this.gm.players.forEach(player => {
                        player.start = 0;
                        //Setup
                        player.hits = {};
                        player.hitsRound = {};
                        this.numbers.forEach(number => {
                            player.hits[number] = 0;
                            player.hitsRound[number] = 0;
                        });
                    });
                    this.hitsRoundStart = this.gm.players[0].hits;
                    this.$forceUpdate();
                    this.clr();
                    resolve();
                });
            },
            setStartingPlayer(id) {
                if (this.gm.debugger) console.log("setting startting player to: " + id)
                this.gm.setActivePlayer(id, true);
                this.gm.setNextState();
            },
            prepareActivePlayer() {
                return new Promise((resolve, reject) => {
                    this.gm.getActivePlayer().throw = 0;
                    this.gm.getActivePlayer().singlescores = [];
                    this.gm.getActivePlayer().hitsRound = {};
                    this.hitsRoundStart = { ...this.gm.getActivePlayer().hits};
                    this.scoreRoundStart = this.gm.getActivePlayer().score;
                    this.clr();
                    resolve();
                })
            },
            winCheck() {
                return new Promise((resolve, reject) => {
                    var winner = false;
                    this.gm.players.forEach(player => {
                        var hits = 0;
                        for (const [key, value] of Object.entries(player.hits)) {
                            if (this.numbers.includes(parseInt(key)))
                                hits += value;
                        };
                        if (hits >= 21) {
                            winner = true;
                            this.gm.players.forEach(player2 => {
                                if (player2.score > player.score && player2.id != player.id) winner = false;
                            });
                        }
                    });
                    resolve({winner: winner});
                })
            },
            winCheckSingle() {
                return new Promise((resolve, reject) => {
                    var player = this.gm.getActivePlayer();
                    var hits = 0;
                    var winner = false;
                    for (const [key, value] of Object.entries(player.hits)) {
                        if (this.numbers.includes(parseInt(key)))
                            hits += value;
                    };
                    if (hits >= 21) {
                        winner = true;
                        this.gm.players.forEach(player2 => {
                            if (player2.score > player.score && player2.id != player.id) winner = false;
                        });
                    }
                    resolve({winner: winner});
                })
            },

            add(number) {
                if (this.logged_in_user == this.gm.getActivePlayer().user_id)
                    this.addDart(number, this.gm.getActivePlayer());
            },
            clr() {
                this.gm.getActivePlayer().throw = 0;
                this.gm.getActivePlayer().singlescores = [];
                this.gm.getActivePlayer().hits = {...this.hitsRoundStart};
                this.gm.getActivePlayer().score = this.scoreRoundStart;
                this.gm.getActivePlayer().hitsRound = {};
                this.throw = 0;
                this.$forceUpdate();
                this.gm.resetRound();
            },
            send() {
                if (this.logged_in_user == this.gm.getActivePlayer().user_id && !this.disabledInput) {
                    this.disabledInput = true;
                     axios.post("/api/games/" + this.game.id + "/sendfullscore", {
                         player: this.gm.getActivePlayer().id,
                         score: this.throw,
                         singlescores: this.gm.getActivePlayer().singlescores
                         }).then(() => {
                        this.throwPoints = this.throw;
                        setTimeout(() => {
                            this.gm.setNextState();
                        }, 250);
                    })
                }
            },
            finishRoundOrSend() {
                if (this.logged_in_user == this.gm.getActivePlayer().user_id  && !this.disabledInput) {
                    if (this.gm.getActivePlayer().singlescores.length > 0 && this.gm.getActivePlayer().singlescores.length < 3) {
                        //add zeros to the remaining darts
                        if (this.dartcounter < 3) {
                            axios.post("/games/singlescore", {dart: 0, times: 3 - this.dartcounter});
                        }
                        this.gm.finishRound();
                    } else {
                        this.send();
                    }
                }
            },
            addDart(dart, player) {
                if (player.singlescores.length >= 3) return;
                if (dart.base === undefined)
                    dart = DartsParser.parse(dart);
                var numberBase = dart.base;
                player.singlescores.push(dart);
                if (isNaN(player.hits[numberBase])) player.hits[numberBase] = 0;
                player.hits[numberBase] += dart.multiplier;
                if (!player.hitsRound[numberBase]) player.hitsRound[numberBase] = 0;
                player.hitsRound[numberBase] += dart.multiplier;
                if (player.hits[numberBase] > 3) {
                    if (this.numbers.indexOf(numberBase) != -1) {
                        var points = (player.hits[numberBase] - 3) * dart.base;
                        player.hits[numberBase] = 3;
                        if (this.checkOpen(numberBase)) {
                            this.throw += points;
                            player.score += points;
                        }
                    }
                }
                if (dart.missed) this.playAudioFile("miss");
                if (dart.base == 25 && dart.multiplier == 2) this.playAudioFile("dbull");
                if (dart.base == 20 && dart.multiplier == 3) this.playAudioTripple(20);
                if (dart.base == 19 && dart.multiplier == 3) this.playAudioTripple(19);
                if (dart.base == 18 && dart.multiplier == 3) this.playAudioTripple(18);
                if (dart.base == 17 && dart.multiplier == 3) this.playAudioTripple(17);
                if (player.singlescores.length >= 3) {
                    this.gm.finishRound();
                }
                this.$forceUpdate();
            },
            checkOpen(number) {
                var returnValue = 0;
                this.gm.players.forEach(player => {
                    if (player.hits[number] >= 3 && !this.gm.isActivePlayer(player.id)) returnValue += 1;
                });
                return returnValue < this.gm.players.length - 1;
            },
            parseContent() {
                //parses the content of the leg to show what happens in this game
                if (!this.content || this.content.start) return;
                var last_active_player_id = 0;
                var last_score = 0;
                this.gm.players.forEach(player => {
                    player.score = this.content.start;
                    this.numbers.forEach(number => {
                        player.hits[number] = 0;
                    });
                });
                //then add points
                this.content.throws.forEach(t => {
                    this.gm.players.forEach(player => {
                        if (t.player == player.id) {
                            t.singlescores.forEach(dart => {
                                if (player.hits[dart.base] !== undefined && dart.base !== 0) {
                                    player.hits[dart.base] += dart.multiplier;
                                    if (player.hits[dart.base] > 3) {
                                        if (this.numbers.indexOf(dart.base) != -1) {
                                            var points = (player.hits[dart.base] - 3) * dart.base;

                                            player.hits[dart.base] = 3;
                                            let canAddPoints = 0;
                                            this.gm.players.forEach(player2 => {
                                                if (player2.hits[dart.base] >= 3 && player2.id != player.id) canAddPoints += 1;
                                            });
                                            if (canAddPoints < this.gm.players.length - 1) {
                                                player.score += points;
                                            };
                                        }
                                    }
                                }
                            });
                            last_active_player_id = player.id;
                            last_score = player.throw;
                        }
                    });
                });
                return {lastplayer:last_active_player_id, lastscore:last_score};
            },
            showWinner() {
                var winner = undefined;
                this.gm.players.forEach(player => {
                    if (player.id == this.game.winner_id) {
                        winner = player;
                    }
                });
                this.winner = winner;
                if (this.winner != null)
                    this.showResults = true;
            },
            backToMatchmaking() {
                window.location.href = "/matchrequests/";
            },
            parseSingleScore(activeplayer, dart) {
                //mark as missed if dart value is 0
                if (dart.value == 0) dart.missed = true;
                this.addDart(dart, activeplayer);
            },
            showNextLeg() {
                this.$bvModal.show('modal-leg-end');
            },
            nextLeg() {
                toastSuccess("Starte n&auml;chstes Leg");
                this.gm.startNextLeg()
                this.$bvModal.hide('modal-leg-end');
            },
            isFirstLeg() {
                if (!this.gameState) return false;
                return this.sets_player1 == 0 && this.legs_player1 == 0 && this.sets_player2 == 0 && this.legs_player2 == 0;
            },
            cricketCounter(number) {
                if (number == 0 || !number) return "&nbsp;"
                var returnValue = "";
                for (let i = 0; i < number; i++) {
                    returnValue += "X"
                }
                return returnValue;
            },
            cricketNumberState(numberBase, player) {
                if (!player || !player.hits) return "startup"; //still in startup
                var playerscount = this.gm.players.length;
                var closedCounter = 0;
                var playerClosed = false;
                this.gm.players.forEach(p => {
                    var hits = p.hits[numberBase];
                    if (hits >= 3) {
                        closedCounter += 1;
                        if (p.id == player.id) {
                            playerClosed = true;
                        }
                    }
                });
                if (closedCounter == playerscount) return "closed";
                else if (!playerClosed && closedCounter > 0) return "open-for-opponent";
                else if (playerClosed) return "open";
                else return "free";
            },
            checkStartingPlayer(player_id) {
                return this.gm.startingPlayerId == player_id
            },
            historyContent() {
                if (!this.content || this.content.start === undefined || this.content.throws === undefined) return [];

                //parse the content throws to generate a nice viewable score list
                if (!this.content || !this.content.throws) return [];
                let players = [];
                this.gm.players.forEach(player => {
                    players.push({id: player.id, score: 0, rows: [], hits: []});
                });

                let roundCounter = 0;
                players.forEach(player => {
                    roundCounter = 0;
                    player.rows.push({
                        score: player.score,
                        round: "-"
                    })
                    this.numbers.forEach(number => {
                        player.hits[number] = 0;
                    });
                })
                if (this.content && this.content.throws) {
                    let roundplayers = 0;
                    for (let i = 0; i < this.content.throws.length; i++) {
                        const t = this.content.throws[i];
                        players.forEach(player => {
                            if (t.player == player.id) {
                                let singlescores = '';
                                if (t.singlescores) {
                                    t.singlescores.forEach(sc => {
                                        singlescores += sc.str + " ";
                                    });
                                    t.singlescores.forEach(dart => {
                                        if (player.hits[dart.base] !== undefined && dart.base !== 0) {
                                            player.hits[dart.base] += dart.multiplier;
                                            if (player.hits[dart.base] > 3) {
                                                var points = (player.hits[dart.base] - 3) * dart.base;

                                                player.hits[dart.base] = 3;
                                                let canAddPoints = 0;
                                                players.forEach(player2 => {
                                                    if (player2.hits[dart.base] >= 3 && player2.id != player.id) canAddPoints += 1;
                                                });
                                                if (canAddPoints < this.gm.players.length - 1) {
                                                    player.score += points;
                                                };
                                            }
                                        }
                                    });
                                }
                                player.rows.push({
                                    score: player.score,
                                    singlescores: singlescores,
                                    round: roundCounter
                                })
                                roundplayers+=1;
                            }
                        })
                        if (roundplayers >= players.length) {
                            roundCounter += 1;
                            roundplayers = 0;
                        }
                    }
                }
                if (window.player && window.player.roundsort == 2) {
                    players.forEach(player => {
                        player.rows = player.rows.reverse();
                    });
                }
                return {players: players, rounds: roundCounter+1, custom: true};
            },
            showSubMenu(name) {
                this.showmenu = name;
            },
            closedCheck(number) {
                let returnValue = 'closed';
                this.gm.players.forEach(player => {
                    if (!player.hits[number] || player.hits[number] < 3) returnValue = ''
                });
                return returnValue;
            }
        }
    }
</script>

<style scoped>

    .cricketContainer {
        margin: 2.5em 0 0 0;
    }

    .cricketScore {
        font-size: 2em;
        border: 1px solid #333;
        margin: 0.2em 0 0 0;
    }

    .cricketScore.free {
        background-color: #fff;
    }
    .cricketScore.open {
        border-color: green;
        background-color: green;
        color: #fff;
    }
    .cricketScore.closed {
        border-color: #888;
        opacity: 0.5;
    }

    .cricketNumber {
        font-size: 2em;
        border: 1px solid #333;
        margin: 0.2em 0 0 0;
    }
    .cricketNumber.free {
        background-color: #fff;
    }
    .cricketNumber.open {
        border-color: green;
        background-color: #fff;
    }
    .cricketNumber.closed {
        border-color: #888;
        opacity: 0.5;
    }

</style>
